if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitting || this.submitButton.getAttribute('aria-disabled') === 'true' ||
            this.submitButton.disabled || this.variantIdInput.disabled || !this.variantIdInput.value) return;
        this.submitting = true;
        this.handleErrorMessage();
        this.cart?.close?.();
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        // Capture the user's choice now, before a different colour can be selected.
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        const execute = async () => {
          const deferred = this.createCartLinesUpdateEvent(variantId, quantity);
          deferred?.promise.catch(() => {});
          let knownState = false;
          try {
            let response, requestError;
            try {
              const result = await fetch(routes.cart_add_url, config);
              response = await result.json();
              if (result.ok === false || response.status) requestError = response.description || response.message || window.cartStrings.error;
            } catch (error) {
              requestError = window.cartStrings.requestError || window.cartStrings.error;
            }
            // add.js may add the remaining stock even when returning422. Always read back.
            const cart = window.CuratedCart ? await window.CuratedCart.refresh() : null;
            knownState = true;
            if (cart && deferred) {
              deferred.resolve({cart: window.StandardEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(cart)});
            } else {
              this.resolveCartLinesUpdate(deferred);
            }
            if (requestError) {
              this.handleErrorMessage(requestError);
              this.dispatchCartErrorEvent(requestError, 'INVALID');
              // Never show an "added successfully" dialog after a partial/unknown request.
              return;
            }
            if (!this.cart) { window.location = window.routes.cart_url; return; }
            // Full refreshed cart is already applied; notification still needs the added line.
            if (this.cart.tagName === 'CART-NOTIFICATION') this.cart.renderContents(response);
            else this.cart.open();
          } catch (error) {
            deferred?.reject(error);
            this.handleErrorMessage(window.cartStrings.syncError || window.cartStrings.error);
            this.dispatchCartErrorEvent(window.cartStrings.syncError || window.cartStrings.error, 'SERVICE_UNAVAILABLE');
          } finally {
            this.submitting = false;
            this.submitButton.classList.remove('loading');
            // If read-back failed, keep this form locked until the customer visits the cart/reloads.
            if (knownState) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          }
        };
        return window.CuratedCart ? window.CuratedCart.run(execute) : execute();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
